import { render, staticRenderFns } from "./ComplieRightStlye.vue?vue&type=template&id=7959818e&scoped=true"
import script from "./ComplieRightStlye.vue?vue&type=script&lang=js"
export * from "./ComplieRightStlye.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightStlye.vue?vue&type=style&index=0&id=7959818e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7959818e",
  null
  
)

export default component.exports